module.exports = __webpack_public_path__ + "static/media/Slide4.c0f1fa1a.JPG";